<template>
    <v-container xl fluid style="overflow: auto;">
        <v-row>
            <v-col cols="12" xs="12" md="12" lg="12" class="pt-0">
                <v-row class="pa-0 mx-0 mt-0 mb-4">
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
                        <div style="display: flex; width:100%; height:100%; justify-content: flex-start;">
                            <hr class="vr"/>
                            <p class="tblName pb-2">Listado de incidencias</p>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                <v-card style="border-radius: 20px; background: white;" elevation="0" class="ml-5 mr-4">
                    <ValidationObserver ref="form" v-slot="{ invalid }">
                        <v-card-text class="px-6 pb-0 pt-8" style="position:relative; background: transparent;">
                            <v-row class="pa-0 ma-0" style="border-radius: 20px; background: transparent;">
                                <template v-if="rol == 'root'">
                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Cliente"
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="cliente_value"
                                                class="pa-0 ma-0"
                                                required 
                                                :error-messages="errors" >
                                            </v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                </template>
                                <v-col v-if="rol == 'root' || rol == 'admin'" cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                                    <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                        <v-autocomplete
                                            outlined
                                            label="Empresa"
                                            :items="empresas"
                                            item-text="nombre"
                                            item-value="id"
                                            persistent-hint
                                            v-model="empresa_value"
                                            required 
                                            :error-messages="errors" 
                                        >
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                                    <ValidationProvider v-slot="{ errors }" name="Tipo de nómina" rules="required">
                                        <v-autocomplete
                                            outlined
                                            label="Tipo de nómina"
                                            :items="itemsTiposNominas"
                                            item-text="claveDescripcion"
                                            item-value="id"
                                            persistent-hint
                                            v-model="tipo_nomina_id"
                                            required 
                                            :error-messages="errors" 
                                        >
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end mx-4">
                            <v-btn 
                                class="btnGuardar" 
                                @click="consultar()" 
                                :disabled="invalid" 
                                :loading="isLoading"
                            >
                                Consultar
                            </v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                <v-card style="border-radius: 20px; background: white;" elevation="0" class="ml-5 mr-4">
                    <v-card-text class="px-0 pb-30px pt-0" style="position:relative; background: transparent;">
                        <v-row class="pa-0 ma-0 areaConsulta informacionGeneralConsulta" style="border-radius: 20px; background: transparent;">
                            <v-col 
                                cols="12" xs="12" sm="12" md="12" 
                                class="pa-0 " 
                                style="min-height:500px;"
                                
                            >
                                <div style="overflow-x: auto;">
                                    <ValidationObserver ref="formTabla" v-slot="{ invalid }">
                                        <perfect-scrollbar class="div-tabla-periodos firstth lastth">
                                            <div v-if="datosTabla.length == 0" class="emptyTableComplementos mt-10" >
                                                <div>No hay elementos para mostrar</div>
                                            </div>
                                            <table v-else class="tbl-incidencias tabla-periodos mt-8 ml-6" >
                                                <thead class="tbl-header">
                                                    <tr>
                                                        <th rowspan=3 class="pl-2 text-start firstth">Clave</th>
                                                        <th rowspan=3 class="pl-2 text-start">Empleado</th>
                                                        <th :colspan="headers.length" class="uno">{{ 'Período solicitado: del ' + fechasPeriodo  }}</th>
                                                        
                                                    </tr>
                                                    <tr>
                                                        <th 
                                                                class="thTitulos dos px-4 text-center"
                                                                v-for="(dia, index) in headers"
                                                        >
                                                            {{ dia.dia }}
                                                        </th>
                                                    </tr>
                                                    <tr >
                                                    
                                                        <th 
                                                            class="thTitulos px-4 text-center"
                                                            v-for="(dia, index) in headers"
                                                        >
                                                            {{ dia.diaLetra }}
                                                        </th>
                                                        
                                                        <!-- <th class="thTitulos px-4 text-center">1</th>
                                                        <th class="lastth thTitulos px-4 text-center">5</th> -->

                                                    </tr>
                                                </thead>
                                                <tbody class="tabla-tbody-periodos">
                                                    <tr v-if="datosTabla.length == 0" >
                                                        <td class="emptyTableComplementos">
                                                            No hay elementos para mostrar
                                                        </td>
                                                    </tr>
                                                    <template v-else>
                                                        <template  v-for="(empleado, index) in datosTabla" >
                                                            <tr class="trBody">
                                                                <td>
                                                                    <div 
                                                                        class="pl-2 pr-4"
                                                                    >
                                                                        {{empleado.clave}}
                                                                    </div>
                                                                </td>
                                                                <td 
                                                                    :class="empleado.color == false ? 'custom-row-false':'custom-row-true'"
                                                                    
                                                                >
                                                                    <!-- <v-avatar>
                                                                        <img
                                                                            :src="empleado.avatar"
                                                                            :alt="empleado.nombre_completo"
                                                                        >
                                                                    </v-avatar> -->
                                                                    <div 
                                                                        class=""
                                                                        style="min-width: 200px;"
                                                                    >
                                                                        {{empleado.nombre_completo}}
                                                                    </div>
                                                                </td>
                                                                <td class="thTitulos px-4" v-for="(dia, index) in empleado.dias">
                                                                    <div style="min-width: 60px;">
                                                                        
                                                                        <div class="d-flex justify-end">
                                                                            <v-menu offset-y>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn 
                                                                                        icon 
                                                                                        :color="dia.valor_status == 'aprobado' ? 'green' : 'red'"
                                                                                        v-bind="attrs"
                                                                                        v-on="on"       
                                                                                    >
                                                                                        <v-icon >{{dia.valor_status == 'aprobado' ? 'mdi-check-circle-outline':'mdi-pause-circle-outline'}}</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <v-list>
                                                                                    <v-list-item>
                                                                                        <v-list-item-content>
                                                                                            <v-list-item-title class="font-weight-bold">Estatus de la incidencia</v-list-item-title>
                                                                                        </v-list-item-content>
                                                                                    </v-list-item>
                                                                                    <v-divider></v-divider>
                                                                                    <v-list-item>
                                                                                        <v-list-item-content>
                                                                                            <v-list-item-title @click="setStatus('estatus_aprobado')">{{'Aprobado'}}</v-list-item-title>
                                                                                            <v-list-item-title @click="setStatus('estatus_pendiente')">{{'Pendiente'}}</v-list-item-title>
                                                                                            <v-list-item-title @click="setStatus('estatus_rechazado')">{{'Rechazado'}}</v-list-item-title>
                                                                                        </v-list-item-content>
                                                                                    </v-list-item>
                                                                                </v-list>
                                                                            </v-menu>    
                                                                        </div>
                                                                        
                                                                        <div>
                                                                            <v-menu offset-y>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <div 
                                                                                        class="div-incidencia text-center" 
                                                                                        :color="colorIncidencia(dia.incidencia)"
                                                                                        :style="{background: colorIncidencia(dia.incidencia)}"
                                                                                        v-bind="attrs"
                                                                                        v-on="on"  
                                                                                    >
                                                                                        {{dia.incidencia.charAt(0)}}
                                                                                    </div>
                                                                                </template>
                                                                                <v-list>
                                                                                    <v-list-item>
                                                                                        <v-list-item-content>
                                                                                            <v-list-item-title class="font-weight-bold">Incidencia/Complemento</v-list-item-title>
                                                                                        </v-list-item-content>
                                                                                    </v-list-item>
                                                                                    <v-divider></v-divider>
                                                                                    <v-list-item>
                                                                                        <v-list-item-content>
                                                                                            <v-list-item-title>{{'Asistencia'}}</v-list-item-title>
                                                                                            <v-list-item-title>{{'Vacaciones'}}</v-list-item-title>
                                                                                            <v-list-item-title>{{'Día festivo'}}</v-list-item-title>
                                                                                        </v-list-item-content>
                                                                                    </v-list-item>
                                                                                </v-list>
                                                                            </v-menu>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                
                                                            </tr>
                                                        </template>
                                                    </template>
                                                    
                                                    <tr v-if="datosTabla.length != 0" >
                                                        <td class="tdBlanco" colspan="11">
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </perfect-scrollbar>
                                    </ValidationObserver>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Notify from "@/plugins/notify";
import apiClientes from '@/api/clientes';
import apiEmpresas from '@/api/empresas';
import apiTipoNomina from '@/api/nominas/tipoNomina';
import apiIncidencias from '@/api/incidencias';
import moment from 'moment';
moment.locale('es');

export default {
    components: {

    },
    data() {
        return {
            datosTabla      : [],
            headers         : [],
            rol             : null,
            datosLogin      : null,
            clientes        : [],
            empresas        : [],
            itemsTiposNominas: [],
            cliente_value   : null,
            empresa_value   : null,
            tipo_nomina_id  : null,
            isSaving        : false,
            isLoading       : false,
            fechasPeriodo   : '',
        }
    },
    computed: {

    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.getEmpresas(val);
            }
        },
        empresa_value: function(val, oldval) {
            if(val != null){
                this.getTiposNominas()
            }
        },
    },
    methods: {
        consultar(){
            let parametros = {
                activo      : true,
                paginate    : false,
                tipo_nomina_id  : this.tipo_nomina_id
            }
            this.isLoading = true
            apiIncidencias.getIncidenciasListado(parametros).then((response) => {
                this.datosTabla = response.data;
                if(this.datosTabla.length > 0){
                    this.fechasPeriodo = this.fechaPeriodo(response.inicio, response.final)
                    let fechas = this.datosTabla[0].dias.map(dia => dia.fecha);
                    this.headers = fechas.map(dia => {
                        let d = dia.split("-")
                        let dddd = moment(dia).format('dddd')
                        return {dia:d[2], diaLetra:dddd}
                    })
                    
                }
                this.isLoading = false
            })
            .catch((err) => {
                this.isLoading = false
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        getClientes(){
            let parametros = {
                activo      : true,
                paginate    : false,
                order       : 'asc',
                order_by    : 'nombre'
            }
            
            apiClientes.getClientes(parametros).then((response) => {
                this.clientes = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        getEmpresas(){
            let parametros = {
                activo      : true,
                paginate    : false,
                order       : 'asc',
                order_by    : 'nombre',
                cliente_id  : this.cliente_value
            }
            apiEmpresas.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        async getTiposNominas() {
            let param = {
                activo      : true,
                paginate    : false,
                cliente_id  : this.cliente_value,
                empresa_id  : this.empresa_value,
            }
            this.itemsTiposNominas = [];
            await apiTipoNomina.find(param).then((response) => {
                this.itemsTiposNominas = response.data;
                this.itemsTiposNominas.map(tipo_nomina => tipo_nomina.claveDescripcion = tipo_nomina.clave + ' - ' + tipo_nomina.descripcion+ " - "+tipo_nomina.nombre_empresa);
            })
            .catch (err => {
                console.log(err);
                Notify.ErrorToast("No se pudieron cargar los tipos de nómina");
            })
        },
        colorIncidencia(incidencia){
            if(incidencia == 'Descanso'){
                return '#AAB9CF'
            }
            else if(incidencia == 'Falta'){
                return 'red'
            }
            else {
                return 'red'
            }
        },
        fechaPeriodo(fechaInicio,fechaFinal){
            let fechaInicioArray = fechaInicio.split("-");
            let inicio = fechaInicioArray[2] + "/" + fechaInicioArray[1]+ "/" + fechaInicioArray[0];

            let fechaFinalArray = fechaFinal.split("-");
            let final = fechaFinalArray[2] + "/" + fechaFinalArray[1]+ "/" + fechaFinalArray[0];

            return inicio + ' al ' +final;

        },
        setStatus(status){
            Notify.InfoToast("Se ha cambiado el estatus a: " + status);
        }
    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;

        if(this.rol == 'root'){
            this.getClientes()
        }
        
    },
    mounted() {

    },
}
</script>

<style scoped>
.firstth {
    border-top-left-radius: 20px !important;
}
.lastth {
    border-top-right-radius: 20px !important;
}
.emptyTableComplementos{
    color: #c5c5c5 !important;
    background:#FFFFFF;
    font-family: "Montserrat" !important;
    font-size: 18px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 22px !important;
    padding-bottom: 50px !important;
    padding-top: 50px !important;
    text-align: center !important;
    border-bottom-left-radius: 20px !important;
    border-bottom-right-radius: 20px !important;
}
.tbl-incidencias .tbl-header {
    background: #F6F6F6;
    border-radius: 10px;
    height: 58px;
}
.div-tabla-periodos{
    height: 73vh!important;
    overflow: scroll;
}

.tabla-periodos{
    border-collapse: collapse;
    border-spacing: 0;
}

.tabla-periodos>thead{
    background: #F6F6F6;
    top: 0px;
    position: sticky;
    z-index: 999;
}

.div-incidencia {
    font-family: "Montserrat" !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 22px !important;
    color: #FFFFFF !important;
    border-radius: 15px;
    margin-right: 10px;
}

</style>